import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DatabaseCreate,
  Database,
  DatabaseUser,
  DatabaseUserCreate,
  DatabaseUserEdit,
} from '../../shared/models/database.models';

@Injectable({
  providedIn: 'root',
})
export class DatabaseService {
  private http = inject(HttpClient);

  createDatabase(data: DatabaseCreate): Observable<Database> {
    return this.http.post<Database>('/database/databases', data);
  }

  deleteDatabase(databaseId: number): Observable<void> {
    return this.http.delete<void>(`/database/databases/${databaseId}`);
  }

  getDatabaseById(databaseId: number): Observable<Database> {
    return this.http.get<Database>(`/database/databases/${databaseId}`);
  }

  getDatabases(
    page?: number,
    search?: string,
    websiteIds?: number[],
  ): Observable<[Database[], number]> {
    let params = new HttpParams();

    const url = '/database/databases';

    if (page) params = params.set('page', String(page));

    if (search) params = params.set('search', search);

    if (websiteIds) params = params.set('websiteIds', websiteIds.join(','));

    return this.http.get<[Database[], number]>(url, { params: params });
  }

  getByWebsiteId(websiteId: number): Observable<Database[]> {
    return this.http.get<Database[]>(`/database/websites/${websiteId}`);
  }

  getUsers(page: number, search?: string): Observable<[DatabaseUser[], number]> {
    let url = `/database/users?page=${page}`;
    if (search) url = `${url}&search=${encodeURIComponent(search)}`;

    return this.http.get<[DatabaseUser[], number]>(url);
  }

  getAllDatabases(): Observable<Database[]> {
    return this.http.get<Database[]>('/database/databases');
  }

  createUser(data: DatabaseUserCreate): Observable<DatabaseUser> {
    return this.http.post<DatabaseUser>('/database/users', data);
  }

  deleteUser(userId: number): Observable<void> {
    return this.http.delete<void>(`/database/users/${userId}`);
  }

  getUserById(userId: number): Observable<DatabaseUser> {
    return this.http.get<DatabaseUser>(`/database/users/${userId}`);
  }

  editUser(userId: number, data: DatabaseUserEdit): Observable<void> {
    return this.http.patch<void>(`/database/users/${userId}`, data);
  }

  deleteDatabaseLog(id: number): Observable<void> {
    return this.http.delete<void>(`/database/databases/logs/${id}`);
  }

  deleteUserLog(id: number): Observable<void> {
    return this.http.delete<void>(`/database/users/logs/${id}`);
  }
}
